/** @internal */
export const OP_PULL_AFTER_NEXT = "PullAfterNext" as const

/** @internal */
export type OP_PULL_AFTER_NEXT = typeof OP_PULL_AFTER_NEXT

/** @internal */
export const OP_PULL_AFTER_ALL_ENQUEUED = "PullAfterAllEnqueued" as const

/** @internal */
export type OP_PULL_AFTER_ALL_ENQUEUED = typeof OP_PULL_AFTER_ALL_ENQUEUED
